import React from 'react';
import { Typography, Box } from '@mui/material';
import BlogPostTemplate from './BlogPostTemplate';

const TrickleStarPost: React.FC = () => {
  const content = (
    <Box>
      <Typography component="p">
        We're excited to announce that HAVEN's Central Air Monitor is now compatible with TrickleStar's 
        Smart Thermostat! This new wireless IAQ integration helps you maximize savings, optimize comfort, 
        and breathe cleaner air.
      </Typography>
      
      <Typography variant="h2" component="h2">
        The Power of Integration
      </Typography>
      
      <Typography component="p">
        By connecting HAVEN's advanced air quality monitoring with TrickleStar's intelligent thermostat 
        control, homeowners can now enjoy:
      </Typography>
      
      <ul>
        <li><strong>Automated ventilation control</strong> based on real-time air quality data</li>
        <li><strong>Energy optimization</strong> that balances air quality and efficiency</li>
        <li><strong>Smart scheduling</strong> that anticipates your needs</li>
        <li><strong>Remote monitoring</strong> and control from anywhere</li>
      </ul>

      <Typography variant="h2" component="h2">
        How It Works
      </Typography>

      <Typography component="p">
        The integration works seamlessly in the background:
      </Typography>

      <Typography variant="h3" component="h3">
        1. Continuous Monitoring
      </Typography>
      <Typography component="p">
        HAVEN's Central Air Monitor continuously tracks key air quality parameters including 
        particulate matter (PM2.5), volatile organic compounds (VOCs), temperature, and humidity.
      </Typography>

      <Typography variant="h3" component="h3">
        2. Intelligent Communication
      </Typography>
      <Typography component="p">
        When air quality drops below optimal levels, HAVEN wirelessly communicates with the 
        TrickleStar Smart Thermostat to initiate appropriate ventilation responses.
      </Typography>

      <Typography variant="h3" component="h3">
        3. Automated Response
      </Typography>
      <Typography component="p">
        The TrickleStar thermostat can automatically adjust HVAC operation to improve air quality 
        while maintaining energy efficiency - no manual intervention required.
      </Typography>

      <Typography variant="h2" component="h2">
        Real-World Benefits
      </Typography>

      <Typography component="p">
        This integration delivers tangible benefits for homeowners:
      </Typography>

      <ul>
        <li><strong>Better Health:</strong> Automatic response to poor air quality conditions</li>
        <li><strong>Lower Energy Bills:</strong> Optimized operation reduces unnecessary runtime</li>
        <li><strong>Peace of Mind:</strong> Set it and forget it - the system handles the rest</li>
        <li><strong>Professional Installation:</strong> Certified HVAC contractors ensure proper setup</li>
      </ul>

      <Typography variant="h2" component="h2">
        Professional Installation Required
      </Typography>

      <Typography component="p">
        Like all HAVEN systems, this integration requires professional installation by a certified 
        HVAC contractor. This ensures:
      </Typography>

      <ul>
        <li>Proper system sizing and configuration</li>
        <li>Compliance with local codes and regulations</li>
        <li>Optimal performance and efficiency</li>
        <li>Ongoing support and maintenance</li>
      </ul>

      <Typography variant="h2" component="h2">
        The Future of Home Automation
      </Typography>

      <Typography component="p">
        This integration represents a significant step forward in home automation. By connecting 
        air quality monitoring with HVAC control, we're moving beyond simple temperature control 
        to comprehensive indoor environmental management.
      </Typography>

      <Typography component="p">
        As we continue to spend more time indoors, these smart integrations become increasingly 
        important for maintaining healthy, comfortable, and efficient homes.
      </Typography>

      <Typography component="p">
        The HAVEN-TrickleStar integration is available now through certified HVAC contractors. 
        Contact your local HAVEN dealer to learn more about bringing intelligent air quality 
        control to your home.
      </Typography>
    </Box>
  );

  return (
    <BlogPostTemplate
      title="HAVEN Meets TrickleStar: Wireless IAQ Integrations"
      author="Christina S"
      date="October 17, 2022"
      readTime="4 min read"
      category="Technology"
      excerpt="HAVEN's Central Air Monitor is now compatible with TrickleStar's Smart Thermostat! Our new wireless IAQ integrations help you maximize savings, optimize comfort, and breathe cleaner air."
      content={content}
    />
  );
};

export default TrickleStarPost; 